import en from "@cinnamon/design-system/esm/translation_en.json";
import jp from "@cinnamon/design-system/esm/translation_jp.json";
import { initReactI18next } from "@cinnamon/design-system/hooks";
import i18n from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import merge from "lodash-es/merge";

import { LANGUAGE_CODE } from "@/constants/config";

import { APP_CONFIG } from "../constants/config";

// Merge language project with language design system
void i18n
  .use(
    resourcesToBackend(async (language: string) => {
      try {
        // Fetch locales from public folder
        const mainLang = await fetch(
          `${import.meta.env.VITE_PUBLIC_URL || ""}/locales/${language}/translation.json`
        ).then((res) => res.json());
        const designSystemLang = language === LANGUAGE_CODE.JAPANESE ? jp : en;

        return merge(designSystemLang, mainLang);
      } catch {
        // Fallback to design system language if fetch fails
        const designSystemLang = language === LANGUAGE_CODE.JAPANESE ? jp : en;
        return designSystemLang;
      }
    })
  )
  // Translation files in /public/locales
  .use(initReactI18next)
  .init({
    fallbackLng: APP_CONFIG.DEFAULT_LANGUAGE,
    lng: APP_CONFIG.DEFAULT_LANGUAGE,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    compatibilityJSON: "v4",
  });

export default i18n;
